<div class="modal-header container-fluid">
  <h4 class="modal-title header-2">{{ title }}</h4>
  <button
    type="button"
    class="accello-icon-btn"
    (mousedown)="isActive = true"
    (mouseup)="isActive = false"
    (mouseleave)="isActive = false"
    (click)="activeModal.dismiss('Cross click')"
  >
    <img
      alt="close"
      [src]="
        isActive
          ? 'assets/images/virtusa-icons/close-dark.svg'
          : 'assets/images/virtusa-icons/close.svg'
      "
    />
  </button>
</div>
<div class="modal-body container-fluid overflow-auto w-100">
  <div class="d-flex flex-column gap-1">
    <div class="trace-div">
      <ng-container *ngIf="getCoveredCriteria(data) as criteria">
        <ol *ngIf="criteria.numbered" class="custom-bullets numbered-list">
          <li *ngFor="let item of criteria.items">{{ item }}</li>
        </ol>
        <ul *ngIf="!criteria.numbered" class="custom-bullets">
          <li *ngFor="let item of criteria.items">{{ item }}</li>
        </ul>
      </ng-container>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end w-100">
    <button
      class="btn-accello-primary-light"
      (click)="activeModal.dismiss('Cross click')"
    >
      Close
    </button>
  </div>
</div>
